/**
 * Normalizes a percentage to a decimal value.
 *
 * @param value - The percentage value to normalize (as a whole number, e.g., 15 for 15%)
 * @returns The normalized percentage as a decimal (e.g., 0.15 for 15%)
 *
 * @example
 * normalizePercentage(15) // returns 0.15
 * normalizePercentage(100) // returns 1
 * normalizePercentage(0) // returns 0
 */
export function normalizePercentage(value: number): number {
  return value > 1 ? value / 100 : value;
}

/**
 * Formats a decimal percentage (0.15) as a display string ("15%").
 *
 * @param decimalPercentage - The percentage as a decimal (e.g., 0.15 for 15%)
 * @returns Formatted string with % suffix
 *
 * @example
 * formatDealPercentage(0.15) // returns "15%"
 * formatDealPercentage(1) // returns "100%"
 * formatDealPercentage(0) // returns "0%"
 */
export function formatDealPercentage(decimalPercentage: number): string {
  if (decimalPercentage <= 1) {
    return `${decimalPercentage * 100}%`;
  }
  return `${decimalPercentage}%`;
}
